module.exports = __webpack_public_path__ + "static/img/mobile-web-bg@t.8fe4ffd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/premium-food-market/mobile-web-bg@t.png
// module id = z/4m
// module chunks = 0